module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$props.solicitacao
    .solicitacao_historicos), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.usuario.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacaoSolicitacao")(item.situacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataHoraFormatada")(item.created_at)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-transform": "none"
      }
    }, [_vm._v(_vm._s(item.observacao))])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Usuário")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Observação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0b85deff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/comuns/solicitacaoHistorico.vue
// module id = 791
// module chunks = 0